<template>
  <div class="flex flex-col px-8 lg:px-16 pt-8 pb-36">
    <div class="flex flex-row justify-start w-full mb-12">
      <div
        v-if="card.TopLabel || card.SubscriptionDealImage"
        :class="[
          'min-h-60',
          'aspect-square',
          'p-4',
          'rounded-full',
          !card.SubscriptionDealImage ? 'bg-surface-primary' : '',
          'dark:bg-surface-information',
          'rotate-[-10deg]',
          'flex',
          'flex-row',
          'justify-center',
          'items-center',
        ]"
      >
        <p
          v-if="card.TopLabel && !card.SubscriptionDealImage"
          class="body-bold-md text-text-on-highlight p-0 m-0 text-16 lg:text-20 leading-16 text-center"
        >
          {{ card.TopLabel }}
        </p>
        <NuxtImg
          v-else-if="card.SubscriptionDealImage"
          :class="`w-[${sanatizedImageSize(card.SubscriptionDealImageSize)}rem]`"
          :src="card.SubscriptionDealImage"
          :alt="`Bild på produkt kopplad till ${card.Title ?? 'erbjudandet'}`"
        />
      </div>

      <SeasonalDealsSimCardShape
        v-if="card.Title"
        class="-rotate-6 z-[-1]"
        inner-classes="top-[-12px] ml-[-4px] md:ml-[-10px] lg:ml-8 xl:ml-24 min-w-100 items-center"
      >
        <p
          class="heading-sm text-text-on-highlight py-12 xl:px-6 whitespace-nowrap"
        >
          <b>{{ card.Title }}</b>
        </p>
      </SeasonalDealsSimCardShape>
    </div>

    <div v-if="card.MainPriceLabel" class="flex flex-row justify-center py-15">
      <BoxedText
        element="p"
        box-color-class="bg-surface-action-1"
        text-color-class="text-text-on-highlight"
        text-class="heading-xs"
        >{{ card.MainPriceLabel }}
      </BoxedText>
    </div>

    <div v-if="card.SubText" class="flex flex-row justify-center text-center">
      <p v-html="markup_markdownLikeTextToHtmlString(card.SubText)"></p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { markup_markdownLikeTextToHtmlString } from '~/utils/markup/allTextTransformations';
import type { SeasonDealMarkupCard } from '~/models/seasonaldeals/SeasonalDealMarkupCard.model';

interface Props {
  card: SeasonDealMarkupCard;
}

const sanatizedImageSize = (value: number | string | undefined) => {
  return Number.isInteger(value) ? value : 9;
};

defineProps<Props>();
</script>
